import React, {useState} from 'react'


export default function Textform(props) {

    function handleUpClick() {
        console.log("Uppercase was clicked"+text);
        let newtext= text.toUpperCase();
        setText(newtext)
        props.showAlert("Converted to upperCase","success");
    }

    function handleLoClick() {
        console.log("lowercase was clicked"+text);
        let newtext= text.toLowerCase();
        setText(newtext)
        props.showAlert("Converted to lowerCase","success");
    }

    function handleClearClick() {
       
        let newtext= "";
        setText(newtext)
        props.showAlert("Cleared text","success");
    }
    
    function handleOnChange (event){
        
        setText(event.target.value);
    }
    function handleToCopy(){
       var text = document.getElementById("myBox");
       text.select();
       navigator.clipboard.writeText(text.value);
       document.getSelection().removeAllRanges();
       props.showAlert("Copy to Clipboard","success");
    }

    function handleSpaces(){
        let newText = text.split(/[ ]+/);
        setText(newText.join(" "))
        props.showAlert("Removed Extra Spaces","success");
    }
   
    const [text, setText] = useState('');
  return (
    <>
    <div className='container' style={{color: props.mode==='dark'?'white':'#042743'}}>
        <h1>{props.heading}</h1>
        <div className="mb-3">
            <textarea className="form-control" onChange={handleOnChange} value={text} style={{backgroundColor: props.mode==='dark'?'rgb(12 107 183)':'white',color: props.mode==='dark'?'white':'#042743'}}id="myBox" rows="8"></textarea>
        </div>
        <button disabled={text.length===0} className="btn btn-primary mx-1 mb-1" onClick={handleUpClick}>Convert to Upper Case</button>
        <button disabled={text.length===0} className="btn btn-primary mx-1 mb-1" onClick={handleLoClick}>Convert to Lower Case</button>
        <button disabled={text.length===0} className="btn btn-primary mx-1 mb-1" onClick={handleClearClick}>Clear Text</button>
        <button disabled={text.length===0} className="btn btn-primary mx-1 mb-1" onClick={handleToCopy}>Copy Text</button>
        <button disabled={text.length===0} className="btn btn-primary mx-1 mb-1" onClick={handleSpaces}>Remove Extra Space</button>
    </div>
    
    <div className="container" style={{color: props.mode==='dark'?'white':'#042743'}}>
         <h2 className="container my-3">See their text Summary...</h2>
         <p>Total Words : {text.split(/\s+/).filter((element)=>{return element.length!==0}).length}</p>
         <p>Total Characters : {text.length}</p>
         <p>{text.split(" ").filter((element)=>{return element.length!==0}).length*0.008} Minutes Read</p>
         <h2>Preview</h2>
           <p>{text.length===0?"Write Something in above Textbox to Preview":text}</p>
    </div>
    </>
  )
}
